namespace Gordic.Epk.WebControls {

    // dono:
    // 1. doplnit logování
    // 4. odstranit starý kód
    // 7. kontrola akcí k posouzení
    // 2. zamezit znovuvyřízení

    // todo:
    // 3. kontrola, jestli se ještě něco vyřizuje po startu ??
    // 5. 602 ID
    // 6. kontrola tempů po serverovém podepsání

    // k zamyšlení:
    // - aktuálně bloknu async. serverově vyřizovanou žádost až na ni přijde řada,
    //   dává smysl bloknout všechny žádosti najednou ?

    // - vypnutí zadaní pinu (test)

  
    export interface ISettlement {
        /** gcontent */
        cnt: GContentType<GEpkDbParamsNew>,
        /** metoda vyvolaná při každé změně / vyřízení žádosti */
        change?: Function | null,
        /** metoda vyvolaná po dokončení vyřízení */
        done?: Function | null,
        /** 
         * předané data vyřizované žádosti 
         * - braná v potaz pouze u single vyřízení z důvodů předání informací pro inicializaci kategorií důvodu podpisu
         */
        row?: Gordic.Wfl.Interface.GPodpisovaKnihaDto
    }

    /**
     * Vyřízení v EPK
     * 
     * @author thazmuka
     * @since 490.1.0.4
     */
    export class Settlement {

        private customLogger: Gordic.Diagnostics.GLog;

        private selectCert: Vyrizeni.VyberCertifikatu;
        private epkConfig = new Vyrizeni.EpkConfig();
        private vyrizSigner = new Vyrizeni.Signer();
        private gridChange: Function;
        private done: Function;

        /** název třídy serverového (async) vyřízení */
        private serverSettlementTaskName: string = "Gordic.Wfl.Server.GEpkSettlementAsyncTask";
        /** guid configu */
        private GuidConfig?: string | null;
        /** info o cert */
        private certInfo: CertInfo;
        /** gcontent */
        private gcontent: GContentType<GEpkDbParamsNew>;
        /** hromadné async vyřízení */
        private async: boolean;
        /** zbývající počet souborů (pro hromadné vyřízení) */
        /** Using certificate's private key is protected by another authentication factor and thus it's needed to wait for it's confirmation*/
        private needsToWaitForConfirmation: boolean;
        /** uživatelský požadavek na přerušení hromadného vyřízení */
        private userRequestedCancel: boolean = false;
        /** neúspěšně vyřízené soubory */
        private fail = 0;
        /*** pořadí vyřízení (podepsání) žádosti na klientovi */
        private clientIndex: number;
        /** list vyřízených žádostí na serveru */
        private tempFinishStack: string[] = [];
        /** příznak hromadného vyřízení */
        private multi: boolean = false;
        /** 
         * předané data vyřizované žádosti
         * - braná v potaz pouze u single vyřízení z důvodů předání informací pro inicializaci kategorií důvodu podpisu
         */
        private ktgRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto;


        // ------------------------------------------------------------------------------------------

        /**
         * konstruktor
         */
        constructor(opt: ISettlement) {

            if (opt != null) {
                if (opt.cnt != null) {
                    this.gcontent = opt.cnt;
                    // zapnutí / vypnutí async. vyřízení
                    this.async = opt.cnt.EpkParams.epk_asyncvyriz === 1;       
                }
                if (opt.change != null) {
                    this.gridChange = opt.change;
                }
                if (opt.done != null) {
                    this.done = opt.done;
                }
                if (opt.row != null) {
                    this.ktgRow = opt.row;
                }
            }
        }

        public run(list: Wfl.Interface.GEpkCompleteConfigDto[]) {

            var dfd = $.Deferred();
            this.gcontent.hideFlash("idFlashFail");

            this.customLogger = new Gordic.Diagnostics.GLog({
                name: "Gordic.Epk.WebControls.Settlement",
                fileName: "Settlement.ts",
                authorCode: 487
            });

            if (list == null || list.length === 0) {
                const log = "jres:32001040"; //RC 32001040 : Neexistují žádosti k hromadnému vyřízení.
                console.warn(log);
                this.customLogger.warn(log);
                return;
            }

            this.customLogger.info("jres:32001046") //RC 32001046 : Spouštím vyřízení žádosti.

            this.init(list);

            const N = new Wfl.WebClient.GSettlementNC(this.gcontent);

            var cancelOperation = (state: boolean) => {
                if (state) {
                    this.userRequestedCancel = true;
                }
            };

            N.beginOperation(cancelOperation);

            this.showDuvodVyrizeniDlg(list)
                .then((changeIxsDpo) => {
                    return this.validationListSign(list);
                })
                .then((isSomethingToSign: boolean) => {
                    if (isSomethingToSign === true) {

                        var item = list[0];

                        // v rámci hromadného vyřízení (prozatím) neprovádím
                        if (this.multi === true) {
                            this.customLogger.info(String.Format("selectWflCertificate - ixsDpo: {0}", item.IxsDpo!));
                            return this.selectCert.select(item.IxsDpo!);
                        }

                        const dfd = $.Deferred();

                        // pokud nebude vyplněno ixsDpo a bude vyplněn parametr kategorie důvodu podpisu,
                        // tak umožním změnu důvodu podpisu
                        new AddIxsDpoDlg(this.gcontent).run(item.IxsDpo!, this.initKtgDto())
                            .then((ixsDpo: string | null) => {

                                if (ixsDpo != null) {
                                    item.IxsDpo = ixsDpo; // doplním změněné ixsDpo, jinak se nechá původní
                                }

                                this.customLogger.info(String.Format("selectWflCertificate - ixsDpo: {0}", item.IxsDpo!));
                                return this.selectCert.select(item.IxsDpo!);
                            })
                            .done((certInfo?: CertInfo) => {
                                dfd.resolve(certInfo);
                            })
                            .fail((reasonResponse: IGReasonResponse) => {
                                dfd.reject(reasonResponse);
                            });


                        return dfd.promise();
                    }
                    return null;
                })
                .then((certInfo?: CertInfo) => {

                    if(certInfo != null)
                        this.certInfo = certInfo;

                    this.needsToWaitForConfirmation = this.certInfo != null &&
                        this.certInfo.certMoreInfo != null &&
                        this.certInfo.certMoreInfo.NeedsToWaitForConfirmation != null ?
                        this.certInfo.certMoreInfo.NeedsToWaitForConfirmation : false;

                    var rqToSignOnClient: Wfl.Interface.GEpkCompleteConfigDto[] = [];
                    var rqToSignOnServer: Wfl.Interface.GEpkCompleteConfigDto[] = list;

                    /** vyzkoušet napřed klientské vyřízení */
                    var runClientSettlement = false;

                    // pravděpodobně se bude podepisovat a nejedná se o typ certifikátu/pečeti 602
                    if (certInfo != null && certInfo.certMoreInfo?.SgnWebServiceType !== Gordic.Security.Service.GSgnWebserviceType.S602_SecuSign) {
                        runClientSettlement = true;
                    }

                    /** stav vizuálního umístění */
                    var visualSignState = this.gcontent.EpkParams.epk_povumipod != null &&
                        this.gcontent.EpkParams.epk_povumipod > 0 &&
                        this.gcontent.EpkParams.gin_pdf_pictpos != null &&
                        this.gcontent.EpkParams.gin_pdf_pictpos > 0;

                    // pravděpodobně se bude podepisovat, vizuální umístění je povoleno a jedná se o jednotlivé vyřízení
                    if (certInfo != null && visualSignState === true && this.multi === false) {
                        runClientSettlement = true;
                    }

                    // INFO:
                    // - na klientu vyřizuji žádosti s klientským certifikátem
                    // - na serveru vyřizuji buď žádosti bez podepsání a nebo se serverovým certifikátem

                    // INFO: (zakomentováno do doby, kdy bude fungovat serverové vyřízení)

                    //if (runClientSettlement === true) {
                    //    rqToSignOnClient = list.filter((rq) => {
                    //        return rq.TypPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat ||
                    //            rq.TypPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
                    //    });
                    //    rqToSignOnServer = list.filter((rq) => {
                    //        return rq.TypPozadavku !== Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat &&
                    //            rq.TypPozadavku !== Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
                    //    });
                    //}

                    // INFO: budeme umožňovat pouze klientské vyřízení
                    rqToSignOnClient = list;
                    rqToSignOnServer = [];

                    this.clientIndex = 0;
                    return this.clientSettlement(rqToSignOnClient, rqToSignOnServer, N)
                })
                .then((rqToSignOnServer: Wfl.Interface.GEpkCompleteConfigDto[]) => {
                    return this.serverSettlement(rqToSignOnServer, N);
                })
                .done(() => {
                    N.endOperation();
                    this.showResult();

                    this.customLogger.info("jres:32001048") //RC 32001048 : Ukončuji vyřízení žádosti.

                    dfd.resolve(0); // úspěšný konec vyřízení
                })
                .fail((reasonResponse: IGReasonResponse) => {

                    this.gcontent.hideFlash("idFlashFail");

                    if (reasonResponse == null) {
                        console.error("jres:32001050"); //RC 32001050 : Došlo k neočekávané chybě při vyřízení. 
                    }
                    else {
                        Gordic.Gui.WebApp.Utils.showReasonFlash(this.gcontent, reasonResponse);
                        if (reasonResponse.handled === false) {
                            this.gcontent.showFlash({ id: "idFlashFail", content: reasonResponse.reason, state: "error" });
                        }
                    }

                    N.endOperation();
                    this.gcontent.signing = false;
                    this.customLogger.info("jres:32001047") //RC 32001047 : Ukončuji vyřízení žádosti končící chybou.

                    if (reasonResponse != null && typeof reasonResponse === "object" && reasonResponse.operation === "cert") {
                        dfd.resolve(1); // povolit znovu vyřízení
                    }
                    else {
                        dfd.reject();
                    }
                })

            return dfd.promise();
        }

        /**
         * vyřízení na straně klienta
         */
        private clientSettlement(rqToSignOnClient: Wfl.Interface.GEpkCompleteConfigDto[], rqToSignOnServer: Wfl.Interface.GEpkCompleteConfigDto[], N: Wfl.WebClient.GSettlementNC) {

            var that = this;
            var dfd = $.Deferred(); 

            if (rqToSignOnClient == null || rqToSignOnClient.length === 0) {
                var text = "EPK: jres:32001030"; //RC 32001030 : Klientsky není co vyřídit.
                this.customLogger.warn(text);
                console.warn(text) 
                return dfd.resolve(rqToSignOnServer).promise();
            }
            else {
                var text = "EPK: jres:32001029"; //RC 32001029 : Spouštím klientské vyřízení.
                this.customLogger.info(text);
                console.info(text); 
            }

            function settlement() {

                const row = rqToSignOnClient[that.clientIndex];
                N.begin(row.Ixp!, "jres:32000776") //RC 32000776 : Probíhá příprava vyřízení

                // -- KOMPLETACE PODPISŮ --
                const komplementaceContent = "jres:32001062 " + row.Ixp!; //RC 32001062 : Probíhá příprava podepsání
                N.progress(row.Ixp!, { content: komplementaceContent, progress: { current: 40, total: 100 } }, that.needsToWaitForConfirmation);
                N.progressOperation(komplementaceContent, 40, that.needsToWaitForConfirmation);


                that.isUserRequestedCancel()
                    .then(() => {
                        that.setLog("BeforeCompleteConfig", row.Ixp!, row.TypPozadavku);
                        return that.epkConfig.epkCompleteConfig(row, that.async, true);
                    })
                    .then((output) => {
                        that.setLog("AfterCompleteConfig", row.Ixp!, row.TypPozadavku);
                        that.GuidConfig = output.GuidConfig;
                        if (that.GuidConfig == null || that.GuidConfig === "") {
                            var message = "Guid of settlement configuration is null OR empty.";
                            console.error(message);
                            that.setLog(message, row.Ixp!, row.TypPozadavku);
                        }
                        return that.isUserRequestedCancel(output.List);
                    })
                    .then((signedConfigs: Wfl.Interface.GEpkSignConfigDto[]) => {
                        var isSign = that.validationRowSign(row);
                        that.customLogger.info("SigningState={0}", isSign);
                        if (isSign === false) {
                            return $.Deferred().resolve(rqToSignOnServer).promise();
                        }
                        else {
                            const podepsatContent = "jres:32000781 " + row.Ixp!; //RC 32000781 : Probíhá podepsání
                            N.progress(row.Ixp!, { content: podepsatContent, progress: { current: 60, total: 100 } }, that.needsToWaitForConfirmation);
                            N.progressOperation(podepsatContent, 60, that.needsToWaitForConfirmation);

                            var casoveRazitko = row.CasRazitko == null ? false : row.CasRazitko;      //thazmuka (7.12.2020) - oprava chyby casoveho razitka - bylo předáváno i když bylo zakázáno
                            that.vyrizSigner.finalizeConfigDelegate(that.gcontent, that.signer, that.multi, that.customLogger);

                            that.customLogger.info("BeforeSign - ixp:{0}, serCislo:{1}, casRazitko:{2}", row.Ixp!, row.SerCislo!, casoveRazitko);
                            return that.vyrizSigner.sign(signedConfigs, {
                                casoveRazitko: casoveRazitko,
                                serCisloEpk: row.SerCislo!
                            }, that.signer, that.certInfo);
                        }
                    })
                    .then((data) => {
                        return that.isUserRequestedCancel(data);
                    })
                    .then((data) => {
                        const vyrizeniContent = "jres:32000777 " + row.Ixp!; //RC 32000777 : Probíhá dokončení vyřízení
                        N.progress(row.Ixp!, { content: vyrizeniContent, progress: { current: 80, total: 100 } });
                        N.progressOperation(vyrizeniContent, 80);

                        if (that.GuidConfig == null || that.GuidConfig === "") {
                            var message = "Guid of settlement configuration is null OR empty.";
                            console.error(message);
                            that.setLog(message, row.Ixp!, row.TypPozadavku);
                        }

                        that.setLog("BeforeFinishSettlement", row.Ixp!, row.TypPozadavku);
                        return that.epkConfig.callEpkFinishSettlementMulti(row, that.GuidConfig, data, that.async);
                    })
                    .done(() => {

                        that.setLog("AfterFinishSettlement", row.Ixp!, row.TypPozadavku);
                        N.end(row.Ixp!, "success", row);
                        // pokusím se provést zápisu do gridu
                        if (that.gridChange != null)
                            that.gridChange([{ Success: true, Ixp: row.Ixp }]);

                        if (that.clientIndex === (rqToSignOnClient.length - 1)) {
                            // ende
                            dfd.resolve(rqToSignOnServer);          // ukončuji vyřízení
                        }
                        else {
                            // shift to next rq
                            that.clientIndex++;
                            settlement();           // spouštím vyřízení znovu
                        }

                    })
                    .fail((reason: IGReasonResponse, userRequestCancel: boolean) => {

                        // info: zde je nunto poznamenat, že by neměla vyskočit tvrdá chyba, ale měla by se případně zobrazit v notifikaci nebo v gridu
                        N.end(row.Ixp!, "error", row, reason);

                        // uživatelské přerušení hromadného vyřízení
                        if (userRequestCancel === true) {
                            dfd.resolve(rqToSignOnServer);                  // ukončuji vyřízení
                        }
                        else {

                            that.fail++;

                            // zapsání neúspěchu do gridu + chybová zpráva
                            that.setLog("Fail", row.Ixp!, row.TypPozadavku);

                            // pokusím se provést zápisu do gridu
                            if(that.gridChange != null)
                                that.gridChange([{ Success: false, Message: reason.reason, Ixp: row.Ixp }]);

                            if (reason != null) {
                                if (that.clientIndex === (rqToSignOnClient.length - 1)) {
                                    // ende
                                    dfd.resolve(rqToSignOnServer);          // ukončuji klientské vyřízení
                                }
                                else {
                                    // shift to next rq
                                    that.clientIndex++;
                                    settlement();           // spouštím vyřízení znovu
                                }
                            }
                            else {
                                // nedefinovaná chyba
                                console.error("Při hromadném vyřízení nastala chyba.");
                                dfd.resolve(rqToSignOnServer);
                            }
                        }
                    })
            }

            // spustím vyřízení
            settlement();
            return dfd.promise();
        }


        /**
         * vyřízení na straně serveru
         */
        private serverSettlement(rqToSignOnServer: Wfl.Interface.GEpkCompleteConfigDto[], N: Wfl.WebClient.GSettlementNC) {

            var that = this;
            var dfd = $.Deferred(); // obsloužit

            const namespace = "Gordic.Epk.WebControls.Settlement";

            if (rqToSignOnServer == null || rqToSignOnServer.length === 0) {
                var text = "EPK: jres:32001031"; //RC 32001031 : Serverově není co vyřídit.
                this.customLogger.warn(text);
                console.warn(text)
                return dfd.resolve().promise();
            }
            else {
                var text = "EPK: jres:32001032"; //RC 32001032 : Spouštím serverové vyřízení.
                this.customLogger.info(text);
                console.info(text);
            }

            var change = (order: number, dto: Gordic.Wfl.Interface.GEpkRqStackList, task: Async.GTask<Async.IGTaskProgress, unknown>, _gridChange?: Function) => {

                // ověření přerušení vyřízení uživatelem
                if (this.userRequestedCancel === true) {

                    Gordic.Async.GTaskManager.cancel(task);

                    var obj: IGReasonResponse = {
                        reason: "jres:32000487", //RC 32000487 : Přerušeno uživatelem.
                        handled: false,
                        type: EReasonType.userCancelled,
                        operation: OperationsEnum.sign
                    }
                    dfd.reject(obj, true);
                    return;
                }

                if (dto != null && dto.Current != null) {

                    var current = 0;
                    var operationText = "jres:32000776"; //RC 32000776 : Probíhá příprava vyřízení
                    var waitForConfirmationFlag = false;

                    if (order === 0) {
                        operationText = "jres:32001063"; //RC 32001063 : Probíhá příprava podepsání
                        current = 40;
                        waitForConfirmationFlag = this.needsToWaitForConfirmation;
                    }
                    else if (order === 1) {
                        operationText = "jres:32001006"; //RC 32001006 : Probíhá podepsání
                        current = 60;
                        waitForConfirmationFlag = this.needsToWaitForConfirmation;
                    }
                    else if (order === 2) {
                        current = 80;
                        operationText = "jres:32001007"; //RC 32001007 : Probíhá dokončení vyřízení
                        waitForConfirmationFlag = false;
                    }
                    const textContent = String.Format(operationText + " {0}", dto.Current.Ixp!);

                    // COVERY
                    N.progressOperation(textContent, current, waitForConfirmationFlag);

                    // PROGRESS NOTIFIKACE
                    N.progress(dto.Current.Ixp!, { content: textContent, progress: { current: current, total: 100 } }, waitForConfirmationFlag);

                    // GRID (změna na gridu pro multi vyřízení)
                    if (_gridChange != null)
                        that.gridChange(dto.Finish);

                }
            };

            var done = (stack: Gordic.Wfl.Interface.GEpkRqStackList, _gridChange?: Function) => {

                // // změna na gridu pro multi vyřízení
                if (_gridChange != null) 
                    that.gridChange(stack.Finish);

                // odstranění progresové notifikace
                N.remove();
                // resolvnu vyřízení po dokončení
                dfd.resolve();
            }; 

            function cleanAll(className: string) {
                var tasks = Gordic.Async.GTaskManager.findByClass(className);
                for (var index = 0; index < tasks.length; index++) {
                    var task = tasks[index];
                    task.cancel(true);
                    console.log("AsyncTaskCancel: " + task.className);
                }
            }

            function settlement() {

                Gordic.Async.GTaskManager.off("." + namespace);

                // doplnění objektu s certifikátem
                if (that.certInfo != null && rqToSignOnServer != null) {
                    for (var i = 0; i < rqToSignOnServer.length; i++) {
                        let item = rqToSignOnServer[i];
                        item.CertInfo = that.certInfo;
                    }
                }

                //#region zjištění, jestli už neprobíhá task, pokud neprobíhá začni task

                Gordic.Async.GTaskManager
                    .getInitPromise()
                    .then(() => {

                        // nalezení všech probíhajících async tasků a jejich zrušení
                        // cleanAll(that.serverSettlementTaskName);

                        Gordic.Async.GTaskManager.delayedStart(that.serverSettlementTaskName, rqToSignOnServer, { clearOnFinish: true, autoClean: true })
                            .then((task) => {
                                Gordic.Async.GTaskManager.on("change." + namespace, that.serverSettlementTaskName, function (o) {
                                    if (this.progress != null && this.progress.current != null) {
                                        change(this.progress.current, JSON.parse(this.progress.text!), task, that.gridChange);
                                    }
                                });

                                Gordic.Async.GTaskManager.on("always." + namespace, that.serverSettlementTaskName, function () {
                                    if (this.progress != null && this.progress.current != null) {
                                        done(JSON.parse(this.progress.text!), that.gridChange);
                                        this.clean();
                                    }
                                });

                            })

                        

                });

            }

            N.begin(null, "jres:32000776"); //RC 32000776 : Probíhá příprava vyřízení

            settlement();

            return dfd.promise();
        }

        // ------------------------------------------------------------------------------------------

        /**
         * obecná inicializace vyřízení
         */
        private init(list: Wfl.Interface.GEpkCompleteConfigDto[]) {

            // nastavení hromadného vyřízení
            if (list.length > 1) {
                this.multi = true;
                this.customLogger.info("jres:32001041") //RC 32001041 : Bude provedeno hromadné vyřízení žádostí.
            }
            else {
                this.multi = false;
                this.customLogger.info("jres:32001042") //RC 32001042 : Bude provedeno jednotlivé vyřízení žádosti.
            }

            const signer = this.initSignObject();
            this.signer = signer;
            // vytvoření instance pro výběr certifikátu
            this.selectCert = new Vyrizeni.VyberCertifikatu(signer);
        }

        private signer: GEpkSigner;

        private initKtgDto() {
            var epkParams = this.gcontent.EpkParams;
            var ktgDto: GKtgDpoSupportDbParamsDto = {
                gin_ele_craz_ob: epkParams.gin_ele_craz_ob,
                gin_ele_craz_pr: epkParams.gin_ele_craz_pr,
                gin_ele_pcasraz: epkParams.gin_ele_pcasraz,
                gin_ele_pdfltv: epkParams.gin_ele_pdfltv,
                gin_pdf_pictpos: epkParams.gin_pdf_pictpos,
                gin_sgn_ktgdp: epkParams.gin_sgn_ktgdp ? 1 : 0
            };
            return ktgDto;
        }

        /**
          * Inicializace podepisovacího objektu 
          * po inicializace kategorií důvodu podpisu
          * thazmuka (19.10.2021)
          * */
        private initSignObject() {

            var that = this;

            function initKtg(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
                var epkParams = that.gcontent.EpkParams;
                var dpoEnabled = epkParams.gin_sgn_ktgdp;
                if (dpoEnabled === false || row.ktg_priz_edit_text === 0)   // pokud důvod nelze editovat, přeskočím
                    return null;
                return that.initKtgDto();
            }

            // MULTI
            if (this.multi === true) {
                // u hromadného vyřízení nepoužíváme kategorie důvodu podpisu!
                console.info("EPK: vytvoření instance epksigneru pro hromadné vyřízení.")
                return new GEpkSigner({ povoleniPraceDialoguDuvoduPodpisu: false });
            }

            // SINGLE
            var ktgDto = initKtg(this.ktgRow);
            if (ktgDto == null) {
                console.info("EPK: vytvoření instance epksigneru pro jednotlivé vyřízení.")
                return new GEpkSigner({ povoleniPraceDialoguDuvoduPodpisu: false });
            }
            else {
                console.info("EPK: vytvoření instance epksigneru (s kategoriemi důvodu podpisu) pro jednotlivé vyřízení.")
                return new GEpkSigner({ cnt: this.gcontent, povoleniPraceDialoguDuvoduPodpisu: true, ktgDto: ktgDto, row: this.ktgRow });
            }
        }

        private showDuvodVyrizeniDlg(list: Wfl.Interface.GEpkCompleteConfigDto[]) {

            if (!(list != null && list.length === 1)) {
                const log = "jres:32001043"; //RC 32001043 : Pravděpodobně se jedná o hromadné vyřízení a proto zadání dialogu důvodu vyřízení přeskočím.
                this.customLogger.warn(log);
                console.warn(log);
                return $.Deferred().resolve().promise();
            }

            var dfd = $.Deferred();
            var dto = list[0];

            // vynucené zadání důvodu při kladném vyřízení (db parametr)
            if (dto.ZpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.Povoleno)
                dto.DuvodVyrizeni = this.gcontent.EpkParams.epk_shreaspos!;

            /** předání důvodu vyřízení z nadřazeného dialogu upřesnění vyřízení */
            var SettlementReason = "";
            var keyPath = String.Format("settlementReason.{0}{1}", dto.Ixp!, dto.SerCislo!.toString());

            if (this.gcontent.globalSettings != null && keyPath !== "") {
                var value: string = this.gcontent.globalSettings.get(keyPath);
                SettlementReason = value == null ? "" : value.trim();
            }

            if (dto.DuvodVyrizeni === true) {
                const log = "Provedu zadání důvodu vyřízení.";
                console.info(log);
                this.customLogger.info(log);
                new Vyrizeni.DuvodVyrizeni().run(this.gcontent, dto.ZpusobVyrizeni!, dto.TypPozadavku!, SettlementReason)
                    .then((opt) => {
                        // nastavení nového důvodu vyřízení
                        dto.VyrizeniTxt = opt.duvod_vyrizeni;
                        if (dto.ZpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) {
                            if (dto.TypPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Predani ||
                                dto.TypPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni) {
                                // (thazmuka 28.6.2023) - aktuálně funkční pouze u jednotlivých vyřízení žádosti
                                dto.IxsFunAssignForward = opt.ixs_fun;
                                dto.IxsSuAssignForward = opt.ixs_su;
                            }
                        }

                        if (dto.VyrizeniTxt == null) {
                            dto.VyrizeniTxt = "";       // spg neakceptuje null hodnotu
                        }

                        dfd.resolve();
                    })
                    .fail((reason: IGReasonResponse) => {
                        dfd.reject(reason);
                    })
            }
            else {
                const log = "jres:32001044" //RC 32001044 : Dialog důvodu vyřízení nezadáváme.
                this.customLogger.info(log);
                console.info(log);
                if (SettlementReason !== "") {
                    const log2 = "jres:32001045" //RC 32001045 : Ukládáme důvod vyřízení předaný z nadřazeného dialogu.
                    this.customLogger.info(log2);
                    console.info(log2);
                    dto.VyrizeniTxt = SettlementReason;
                }

                if (dto.VyrizeniTxt == null) {
                    dto.VyrizeniTxt = "";       // spg neakceptuje null hodnotu
                }

                dfd.resolve();
            }

            return dfd.promise();
        }

        /**
         * ukaž výsledek hromadného vyřízení (vyhodnocení, které soubory se úspěšně/neúspěšně vyřídily a dle toho zobrazit flash)
         */
        private showResult() {
            // uživatelské přerušení hromadných operací
            if (this.userRequestedCancel) {
                this.gcontent.showFlash({
                    id: "id-flash-user-request-cancel",
                    content: "jres:32001034", //RC 32001034 : Vyřízení bylo přerušeno.
                    state: "warning"
                });
            }
            else {
                if (this.fail > 0) {
                    this.gcontent.showFlash({
                        id: "id-flash-result",
                        content: "jres:32000325", //RC 32000325 : Některé záznamy se nepodařilo vyřídit.
                        state: "error"
                    });
                }
                else {
                    this.gcontent.showFlash({
                        id: "id-flash-result",
                        content: "jres:32001035", //RC 32001035 : Vyřízení bylo dokončeno.
                        state: "info"
                    });
                }
            }
            // už nepodepisuji
            this.gcontent.signing = false;
            this.done();
        }

        /** 
         * přerušení vyřízení uživatelem
         */
        private isUserRequestedCancel(customDto?: any) {
            var dfd = $.Deferred();
            if (this.userRequestedCancel === true) {
                var obj: IGReasonResponse = {
                    reason: "jres:32000487", //RC 32000487 : Přerušeno uživatelem.
                    handled: false,
                    type: EReasonType.userCancelled,
                    operation: OperationsEnum.sign
                }
                dfd.reject(obj, true);
            }
            else {
                dfd.resolve(customDto);
            }
            return dfd.promise();
        }

        /**
        * nastavení logu
        * @param name název 
        * @param ixp identifikátor žádosti
        * @param typPozadavku typ požadavku
        */
        private setLog(name: string, ixp: string, typPozadavku: any) {
            // thazmuka (30.03.2021) - zalogování do WK logu typ požadavku
            var typ_pozad_pod_txt = getTypPozadPodTxtUtils(typPozadavku);
            var message = String.Format("{0} - row: {1}, typ_pozad_pod: {2} ({3})", name, ixp, typPozadavku, typ_pozad_pod_txt);
            this.customLogger.info(message);
        }


        /**
         * hromadná validace, jestli je co podepisovat
         */
        private validationListSign(list: Wfl.Interface.GEpkCompleteConfigDto[]) {
            var dfd = $.Deferred();
            var sign = false;
            for (var x = 0; x < list.length; x++) {
                sign = this.validationRowSign(list[x]);
                if (sign === true)
                    break;
            }

            dfd.resolve(sign);
            return dfd.promise();
        }

        /**
         * hromadná validace, jestli je co podepisovat
         */
        private validationRowSign(row: Wfl.Interface.GEpkCompleteConfigDto) {
            var sign = false;
            if (row.ZpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.Povoleno) {
                if (row.TypPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat || row.TypPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) {
                    sign = true;
                }
            }
            return sign;
        }


    }

}